module.exports = __webpack_public_path__ + "img/mai_tai.64ea24bd.jpg";